import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=676d67f2&scoped=true&"
import script from "./BaseWrapper.vue?vue&type=script&lang=js&"
export * from "./BaseWrapper.vue?vue&type=script&lang=js&"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=676d67f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d67f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('676d67f2')) {
      api.createRecord('676d67f2', component.options)
    } else {
      api.reload('676d67f2', component.options)
    }
    module.hot.accept("./BaseWrapper.vue?vue&type=template&id=676d67f2&scoped=true&", function () {
      api.rerender('676d67f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/wrapper/BaseWrapper.vue"
export default component.exports